<script lang="ts">
    import { onMount } from "svelte"

    export let value: number
    export let duration: number = 2000

    let currentValue = 0

    // only 100 steps overall, so count step
    const step = Math.round(value / 100) + 1

    // count up to value
    onMount(() => {
        const interval = setInterval(
            () => {
                if (currentValue < value) {
                    currentValue += step
                    if (currentValue > value) {
                        currentValue = value
                    }
                } else {
                    clearInterval(interval)
                }
            },
            duration / (value / step)
        )

        return () => clearInterval(interval)
    })
</script>

<span class="counting">{currentValue}</span>
